<template>
    <div class="text-center">
      <v-dialog dark v-model="dialog" width="500"> 

        <v-card>
        <v-card-title class="text-h5" style="background-color: #161d30;">
            Contador caja efectivo
        </v-card-title>

        <v-card-text style="background-color: #283045;" class="pt-4">
            <v-simple-table :loading="loading" class="mb-2">
                <template v-slot:default>
                <thead>
                    <tr>
                    <th class="text-center"> Cantidad </th>
                    <th class="text-center" style="min-width: 150px;"> Denominacion (bs) </th>
                    <th class="text-left" style="min-width: 120px;"> Total </th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(n,i) in nominaciones" :key="i">
                        <td > 
                            <v-text-field label="" v-model.number="n.cantidad" type="number" dense outline hide-details></v-text-field> 
                        </td>
                        <td class="text-right">
                            {{ n.valor }}
                        </td>
                        <td>
                            {{ parseFloat((n.valor * n.cantidad).toFixed(2)) }} bs.
                        </td>
                    </tr>
                    <tr>
                        <td></td>
                        <td>Total</td>
                        <td>{{gettotal}} bs</td>
                    </tr>
                </tbody>
                </template>
            </v-simple-table>

            <div class="text-center">
                <v-btn tile color="success" class="mr-4" @click="asignarTotal()" > Aceptar </v-btn>
            </div> 
        </v-card-text> 
      </v-card>
  
        
      </v-dialog>
    </div>
  </template>

<script> 
import xaxios from '@/xaxios';

export default {
  data () {
    return {
      dialog: false,
      valid: true,
      loading: false, 
      msg: '', 
      nominaciones:[],
      denos:[],
    }
  },

  computed:{
    gettotal(){
        let total = 0;
        this.nominaciones.forEach(n=>{
            total += parseFloat((n.valor * n.cantidad).toFixed(2)); 
        });
        total = parseFloat((total*1).toFixed(2))
        return total;
    }
  },

  methods: {
    openmodal(denominacion=null, denominaciones=[]){
        this.dialog = true;  
        this.item = denominacion;
        this.denos = denominaciones;
        this.nominaciones.forEach(n=>{
            n.cantidad = 0;
        });
    },
    async cargarNominas(){
        this.loading = true;
        this.nominaciones = [];
        let url = `${process.env.VUE_APP_API_REST}/api/v1/esam/denominaciones`;
        if(this.eliminados) url += '?eliminados=true';
        const res = await xaxios.get(url).then(x=>x).catch(x=>x);
        if(res && res.data ) {
            let rs = res.data.data;
            rs.forEach(x=>{
                x.cantidad = 0
            });
            rs.sort((a,b)=> b.valor - a.valor)
            this.nominaciones = rs; 
        }
        this.loading = false;
    },
    asignarTotal(){ 
        this.dialog = false;
        const vue = this;
        this.denos.forEach((x,i)=>{
            if(i == 0 ){ // solo la fila de efectivo 
                x.contado = vue.gettotal;
                x.diferencia = parseFloat((x.contado - x.calculado).toFixed(2));
            }else{
                x.contado = 0;
                x.diferencia = 0;
            }
        })

        // window.console.log(JSON.stringify(this.nominaciones,null,4));
        this.$emit("oncontador",this.nominaciones)
    }, 
    },

    mounted(){
        this.cargarNominas();
    }
}
</script>